import Flex from '@Resources/styles/flex.scss';
import { TextField } from '@mui/material';
import cx from 'classnames';
import _isNil from 'lodash/isNil';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { FileType } from '@Components/FileUploadDropzone/FileTypes';
import FileUploader from '@Components/FileUploadDropzone/FileUploadDropzone';
import ModalFooter from '@Components/ModalComponents/ModalFooter';
import Styles from './FileUpload.scss';
import { areFilesValid } from './Helpers';

const UploadFileStep = (props) => {
    const {
        onSelectFile,
        onSelectFileError,
        canSubmitFile,
        onCancel,
        isSubmitting,
        onSubmit,
        newFolderName,
        editFolderName,
        setFooter,
        files,
    } = props;

    const [fileValidation, setFileValidation] = useState(null);

    const handleEditFolderName = (e) => {
        editFolderName(e.target.value);
    };

    const handleSelectFiles = (files: Array<File>) => {
        const validationResult = areFilesValid(files);

        setFileValidation(validationResult);
        if (validationResult.isValid) {
            onSelectFile(files, validationResult.fileType);
        } else {
            onSelectFileError();
        }
    };

    useEffect(() => {
        setFooter(
            <ModalFooter
                id="file-upload-footer"
                onCancel={onCancel}
                isSubmitting={isSubmitting}
                onSubmit={onSubmit}
                canSubmit={canSubmitFile}
                submitText={`Submit`}
                hideSubmit={!canSubmitFile}
            />
        );
    }, [isSubmitting, canSubmitFile, files]);

    return (
        <div className={cx(Flex.flex, Flex.column, Flex.alignItemsCenter)}>
            <div
                id="file-upload-container"
                className={cx(
                    Styles.fuDropzoneContainer,
                    Flex.flex,
                    Flex.column
                )}
            >
                <FileUploader
                    id="file-upload-dropzone"
                    acceptedTypes={[FileType.CSV, FileType.JPG]}
                    onSelectFile={handleSelectFiles}
                />
                <span className={Styles.fuFileTypes}>
                    Allowed Files: One CSV, or Many JPGs
                </span>
                {fileValidation && (
                    <span
                        id="file-validation-msg"
                        className={cx(
                            Styles.fuFileTypes,
                            fileValidation.isValid
                                ? Styles.fuValidationSuccess
                                : Styles.fuValidationError
                        )}
                    >
                        {fileValidation.message}
                    </span>
                )}

                {/* {fileName !== "" &&
                    <div className={Styles.fuFolderNameContainer}>
                        <span className={Styles.fuSelectedFileSpan}>{fileName}</span>
                        <TextField
                            value={newFolderName}
                            onChange={handleEditFolderName}
                            placeholder="Folder Name"
                            label="Folder Name"
                            disabled={isSubmitting}
                            sx={{ flexGrow: 1 }}
                            size='small'
                        />
                    </div>
                } */}
            </div>
        </div>
    );
};

UploadFileStep.propTypes = {
    onSelectFile: PropTypes.func,
    onSelectFileError: PropTypes.func,
    canSubmitFile: PropTypes.bool,
    onCancel: PropTypes.func,
    isSubmitting: PropTypes.bool,
    fileName: PropTypes.string,
    onSubmit: PropTypes.func,
    newFolderName: PropTypes.string,
    editFolderName: PropTypes.func,
    setFooter: PropTypes.func,
    files: PropTypes.array,
};
export default UploadFileStep;
